module.exports = __webpack_public_path__ + "static/media/winners.a9540c5a.png";